/* Feedogo: shared live chat on the live feeder page.
   The page's chat used to keep notes in each visitor's own browser, so nobody else saw them. This loads and posts
   messages through the Feedogo backend (/api/comments), so everyone watching a feeder sees the same chat.
   One message per visitor per minute: the send button counts down here, and the backend refuses faster ones.
   Admins hide unwanted messages in 后台 → 内容管理 → 评论管理. If the backend can't be reached, the page keeps its
   old in-browser notes. Like the other feedogo-*.js helpers it only adds a script to the feeder iframe. */
(function () {
  'use strict';
  var FRAME_ID = 'feedogo-feeder-frame';
  var MARK = 'feedogo-live-chat';

  // Runs inside the feeder iframe.
  function chat() {
    var C = window.LanglangCommunity;
    if (!C || C.fgLive) return;
    C.fgLive = 1;
    var API = (typeof feedogoApiOrigin !== 'undefined' && feedogoApiOrigin) || 'https://srv1134592.hstgr.cloud:8443';
    var WAIT = 60, LAST = 'fgChatLast';
    var localList = C.list, localAdd = C.add, cache = {}, mine = {}, offline = false, timer = null;
    var $ = function (id) { return document.getElementById(id); };
    function changed() { window.dispatchEvent(new Event('langlang-comments-changed')); }
    function station() {
      var m = /·\s*(\S+)\s*$/.exec(($('commentStation') || {}).textContent || '');
      return m ? m[1] : '';
    }
    function item(r) {
      return {
        id: r.id, stationCode: r.station, stationName: '', author: r.author || 'Guest', text: r.text,
        createdAt: r.created * 1000, demo: false,
        reply: r.reply ? { author: 'Feedogo', text: r.reply, createdAt: r.created * 1000 } : null
      };
    }
    function load(code) {
      if (!code) return;
      fetch(API + '/api/comments?station=' + encodeURIComponent(code), { cache: 'no-store' })
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (rows) {
          var ids = {};
          cache[code] = rows.map(function (r) { ids[r.id] = 1; return item(r); });
          // keep my just-sent messages until the server list includes them
          (mine[code] || []).forEach(function (m) { if (!ids[m.id]) cache[code].unshift(m); });
          offline = false;
          changed();
        })
        .catch(function () { if (!cache[code]) { offline = true; changed(); } });
    }
    function left() {
      var last = 0;
      try { last = +localStorage.getItem(LAST) || 0; } catch (e) {}
      return Math.max(0, Math.ceil(WAIT - (Date.now() - last) / 1000));
    }
    function countdown() {
      var btn = document.querySelector('#commentForm .primary-action');
      clearInterval(timer);
      function step() {
        var s = left();
        if (!btn) return;
        if (s > 0) { btn.setAttribute('data-wait', ''); btn.textContent = s + 's'; btn.disabled = true; }
        else { btn.removeAttribute('data-wait'); btn.textContent = 'Post note'; btn.disabled = false; clearInterval(timer); }
      }
      step();
      if (left() > 0) timer = setInterval(step, 1000);
    }
    function say(text) { var f = $('commentFeedback'); if (f) f.textContent = text; }
    function drop(code, id) {
      mine[code] = (mine[code] || []).filter(function (m) { return m.id !== id; });
      if (cache[code]) cache[code] = cache[code].filter(function (m) { return m.id !== id; });
      changed();
    }

    C.list = function (code) {
      if (offline) return localList(code);
      if (!cache[code]) { load(code); return []; }
      return cache[code].slice();
    };
    C.add = function (st, nickname, text) {
      text = String(text || '').trim();
      if (!text || text.length > 500) throw new Error('Please enter a message (1–500 characters).');
      if (offline) return localAdd(st, nickname, text);
      var wait = left();
      if (wait > 0) throw new Error('One message a minute, please. You can send again in ' + wait + 's.');
      var cust = window.feedogoCustomer || {};
      var author = String(nickname || '').trim().slice(0, 20) || (cust.loggedIn && cust.first) || 'Guest';
      var code = st.code, tmp = { id: 'mine-' + Date.now(), stationCode: code, stationName: st.name, author: author, text: text, createdAt: Date.now(), demo: false, reply: null };
      try { localStorage.setItem(LAST, String(Date.now())); } catch (e) {}
      (mine[code] = mine[code] || []).unshift(tmp);
      (cache[code] = cache[code] || []).unshift(tmp);
      fetch(API + '/api/comments', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ station: code, author: author, text: text }) })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (body) {
            if (res.ok) { tmp.id = body.id || tmp.id; return; }
            drop(code, tmp.id);
            if (res.status === 429) {
              try { localStorage.setItem(LAST, String(Date.now() - (WAIT - (body.retry || WAIT)) * 1000)); } catch (e) {}
              say('One message a minute, please. Try again in ' + left() + 's.');
            } else {
              try { localStorage.removeItem(LAST); } catch (e) {}
              say('Your message was not sent. Please try again.');
            }
            countdown();
          });
        })
        .catch(function () {
          drop(code, tmp.id);
          try { localStorage.removeItem(LAST); } catch (e) {}
          say('Your message was not sent. Check your connection and try again.');
          countdown();
        });
      // the page writes its own "posted" note right after this returns; replace it
      setTimeout(function () { say(''); countdown(); }, 0);
      return tmp;
    };

    // Enter sends; Shift+Enter is a new line on desktop
    var box = $('commentText');
    if (box) box.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
        e.preventDefault();
        var form = $('commentForm');
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      }
    });
    setInterval(function () { if (document.visibilityState === 'visible') load(station()); }, 8000);
    load(station());
    countdown();
  }

  function tick() {
    try {
      var f = document.getElementById(FRAME_ID);
      var w = f && f.contentWindow, d = w && w.document;
      if (!d || !d.body || !w.LanglangCommunity || !d.getElementById('commentForm') || d.getElementById(MARK)) return;
      var s = d.createElement('script');
      s.id = MARK;
      s.textContent = '(' + chat.toString() + ')();';
      d.body.appendChild(s);
    } catch (e) {}
  }

  setInterval(tick, 300);
})();
